module.exports = __webpack_public_path__ + "img/sl.89072bb0.svg";